import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetAcessosPorDia } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, larguraColuna, eixoContagem, eixoDias, formatarNumero, tooltipDias, useIndicador } from '../helpers'
import { Destaque } from '../styles'

export default function AcessosPorDia({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorDia, filters, (d) => d.length === 0)
  const dias = data?.map((item) => item.dia) || []
  const valores = data?.map((item) => item.qtdeDia) || []
  const total = data?.reduce((soma, item) => soma + item.qtdeDia, 0) || 0

  const options = {
    chart: { type: 'bar' },
    colors: [CORES.primaria],
    plotOptions: { bar: { columnWidth: larguraColuna(dias.length), borderRadius: 3 } },
    xaxis: eixoDias(dias),
    yaxis: eixoContagem(valores),
    tooltip: { ...tooltipDias, y: { formatter: formatarNumero } },
  }

  return (
    <ChartCard
      title="Acessos por dia"
      subtitle="Acessos às transmissões ao vivo"
      status={status}
      destaque={
        <Destaque>
          <strong>{formatarNumero(total)}</strong>
          <span>no período</span>
        </Destaque>
      }
    >
      <ApexCharts options={options} series={[{ name: 'Acessos', data: valores }]} type="bar" height={280} />
    </ChartCard>
  )
}
